/**
 * @file src/components/AppHeader.ts 移动端公共 header 组件
 * @author wangyuzhen01@baidu.com
*/

// import {getTrackValue, getUserInfo, loginLink, cacheCurrUrl, getUrlParam} from '../utils/util';
import {ConfigDetail, Options, UserInfo} from '../interface/common'
import {globalConfig, configDetail as menuConfigDetail, funcManageConfig, loginHost, qifuHost, cloudHost} from '../common/config';
import {getUrlParam, getTrackValue, loginLink, cacheCurrUrl, getUserInfo} from '../utils/util'
import loginLogo from '../assets/images/self.svg';
import navLogo from '../assets/images/nav.svg';
import closeImg from '../assets/images/close.svg';
import appLogo from '../assets/images/app-qifu-logo.svg';

export default class AppHeader {
    // Header 将要挂载到的 dom 节点
    $el: null | HTMLElement = null;

    // 界面类型
    pageType = '';

    // 配置的详细信息
    configDetail: ConfigDetail;

    constructor(options: Options) {
        const {el, pageType, configDetail} = options;
        this.$el = el;

        this.pageType = pageType;
        this.configDetail = configDetail
            || globalConfig.getConfigDetailByPageType(this.pageType)
            || menuConfigDetail;
        this.createHeader();
    }
    // 导航左侧tab
    createNavLeft() {
        const menu = this.configDetail.menuItems
            .map(item => '<div class="app-nav-content-l-item">' + item.label + '</div>')
            .join('');
        
        return `<div class="qifu-app-nav-content-l">
                  ${menu}
                  <a class="app-nav-content-l-item-footer" href="${cloudHost}" target="_blank">
                      返回智能云首页
                  </a>
                </div>`;
    }
    // 导航右侧内容区
    createNavRight() {
        return `
        <div class="qifu-app-nav-content-r"></div>`
    }

    async createHeader() {
        if (!this.$el) {
            return;
        }
        const template = `
            <header class="qifu-app-header-sdk-container">
                <div class="qifu-app-header-content">
                    <div class="app-header-content-left">
                        <a class="app-cloud-logo" href="${cloudHost}" target="_blank">
                            <img src="${appLogo}" alt="企服logo"/>
                        </a>
                        <a class="app-qifu-logo" href="${qifuHost}" target="_blank"></a>
                    </div>
                    <div class="app-header-content-right">
                        <div class="app-header-login-status">
                            <img src="${loginLogo}" />
                        </div>
                        <div class="app-header-func-btn">
                            <img src="${navLogo}" />
                        </div>
                    </div>
                </div>
                <div class="qifu-app-nav-content">
                    ${this.createNavLeft()}
                    ${this.createNavRight()}
                </div>
                <div class="qifu-app-login-content">
                <div class="qifu-app-login-container">
                    <a class="qifu-app-login-login" href="${loginLink()}?redirect=${cacheCurrUrl()}">登录</a>
                    <a class="qifu-app-login-reg" href="${loginLink()}?redirect=${cacheCurrUrl()}">免费注册</a>
                </div>
                    <div class="qifu-app-login-func-container">
                        ${this.createFuncManage()}
                    </div>
                </div>
            </header>
        `;
        /* bca-disable */
        this.$el.innerHTML = template;
        setTimeout(() => {
            this.navBindClick();
            this.switchNav();
            this.clickPersonalCenter();
            this.loginStatusSwitch();
            this.dynamicBoxHeightCalc();
        });
    }

    // 计算外壳高度
    dynamicBoxHeightCalc() {
        const contentDom:any = document.querySelector('.qifu-app-header-content');
        const containerDom:any = document.querySelector('#qifu-common-header_of_sdk');
        if (contentDom && containerDom) {
            const contentDomObj =  contentDom.getBoundingClientRect();
            containerDom.style.height = contentDomObj.height + 'px';
        }
    }

    // 处理登录注册
    async loginStatusSwitch() {
        const res: UserInfo = await getUserInfo();
        const loginContainer = document.querySelector('.qifu-app-login-container');
        const loginIcon = document.querySelector('.app-header-login-status');
        if (res.hasLogin) {
            loginContainer.innerHTML = `
                <a class="qifu-app-login-display">${res?.displayName}</a>
                <a class="qifu-app-login-reg" href="${loginHost}/logout">退出</a>`;
            loginIcon.innerHTML = `<div class="app-header-login-icon">${res.displayName.charAt(0)}</div>`
        }
    }

    createFuncManage() {
        return funcManageConfig.map(item => (
            `<a class="qifu-app-login-func-item" href="${item.link}">${item.label}</a>`
        )).join('')
    }
    // nav绑定点击事件
    navBindClick() {
        const menuItem = document.querySelectorAll('.qifu-app-nav-content-l > div');
        const menuRight = document.querySelector('.qifu-app-nav-content-r');
        const index = getUrlParam('select') || 0;  // 初始选中
        menuItem[index].className = 'app-nav-content-l-item app-nav-content-l-item-active';
        menuRight.innerHTML = this.createRightContent(this.configDetail.menuItems[index], index);
        Array.from(menuItem).forEach((item, i) => {
            item.addEventListener('click', () => {
                Array.from(menuItem).forEach(item => item.className = 'app-nav-content-l-item');
                menuItem[i].className = 'app-nav-content-l-item app-nav-content-l-item-active';
                menuRight.innerHTML = this.createRightContent(this.configDetail.menuItems[i], i);
            })
        })
    }

    // 生成右侧child
    createRightContent(child, index) {
        const children = child.childrenItems;
        const trackQuery = this.createTrack();
        if (children && children.length > 0) {
            return children.map((item, i) => {
                if (child.targetUrl && i === 0) {
                    return `<a href="${child.targetUrl}${trackQuery}&select=${index}" class="app-header-content-right-value app-header-content-right-entry">${child.label}</a>
                        <a href="${item.targetUrl}${trackQuery}&select=${index}" class="app-header-content-right-value">${item.label}</a>
                    `;
                }
                return `<a href="${item.targetUrl}${trackQuery}&select=${index}" class="app-header-content-right-value">${item.label}</a>`;
            }).join('');
        }
        return `<a href="${child.targetUrl}${trackQuery}&select=${index}" class="app-header-content-right-value app-header-content-right-entry">${child.label}</a>`;
    }

    // 导航展开收回
    switchNav() {
        const switchBtn = document.querySelector('.app-header-func-btn');
        const funcImg = switchBtn.querySelector('img');
        const navContentR = document.querySelector('.qifu-app-nav-content-r');
        const navContent: any = document.querySelector('.qifu-app-nav-content');
        const funcContent: any = document.querySelector('.qifu-app-login-content');

        let count = 0;
        switchBtn.addEventListener('click', () => {
            funcImg.setAttribute('src', count % 2 === 0 ? closeImg : navLogo);
            navContent.style.visibility = `${count % 2 === 0 ? 'visible' : 'hidden'}`;
            navContent.style.opacity = `${count % 2 === 0 ? '1' : '0'}`;
            funcContent.style.visibility = 'hidden';
            funcContent.style.opacity = '0';
            count++;
        });
        navContentR.addEventListener('click', (e) => {
            e.stopPropagation();
            funcImg.setAttribute('src', navLogo);
            navContent.style.display = 'hidden';
            navContent.style.opacity = '0';
        });
    }
    // 个人中心展开收回
    clickPersonalCenter() {
        const switchBtn = document.querySelector('.app-header-func-btn');
        const funcImg = switchBtn.querySelector('img');
        const selfBtn = document.querySelector('.app-header-login-status');
        const funcContent: any = document.querySelector('.qifu-app-login-content');
        const navContent: any = document.querySelector('.qifu-app-nav-content');
        let count = 0;
        selfBtn.addEventListener('click', () => {
            funcImg.setAttribute('src', navLogo);
            funcContent.style.visibility = `${count % 2 === 0 ? 'visible' : 'hidden'}`;
            funcContent.style.opacity = `${count % 2 === 0 ? '1' : '0'}`;
            navContent.style.visibility = 'hidden';
            navContent.style.opacity = '0';
            count++;
        });

    }

    // 生成跟踪track
    createTrack(): string {
        let trackData = getTrackValue() || `${this.pageType}_QifuHeader`;
        trackData = trackData.toLowerCase();
        return `?trace=${trackData}&pageResource=${trackData}`;
    }
}
